import { CALL_API, Schemas } from '../../common/middleware/api';

export const PAYMENTS_REQUEST = 'PAYMENTS_REQUEST';
export const PAYMENTS_SUCCESS = 'PAYMENTS_SUCCESS';
export const PAYMENTS_FAILURE = 'PAYMENTS_FAILURE';

export const PAYMENT_FETCH_REQUEST = 'PAYMENT_GET_REQUEST';
export const PAYMENT_FETCH_SUCCESS = 'PAYMENT_GET_SUCCESS';
export const PAYMENT_FETCH_FAILURE = 'PAYMENT_GET_FAILURE';

export const SET_SUBGRADE_REQUEST = 'SET_SUBGRADE_REQUEST';
export const SET_SUBGRADE_SUCCESS = 'SET_SUBGRADE_SUCCESS';
export const SET_SUBGRADE_FAILURE = 'SET_SUBGRADE_FAILURE';

export const TAKEPAYMENTS_CARD_UPDATE_REQUEST = 'TAKEPAYMENTS_CARD_UPDATE_REQUEST';
export const TAKEPAYMENTS_CARD_UPDATE_SUCCESS = 'TAKEPAYMENTS_CARD_UPDATE_SUCCESS';
export const TAKEPAYMENTS_CARD_UPDATE_FAILURE = 'TAKEPAYMENTS_CARD_UPDATE_FAILURE';

export const PaymentTypes = {
	Lesson: 'lesson',
	IndividualConsultation: 'individualConsultation',
	Workshop: 'workshop'
}

export const loadPayments = (options) => ({
	[CALL_API]: {
		types: [PAYMENTS_REQUEST, PAYMENTS_SUCCESS, PAYMENTS_FAILURE],
		endpoint: 'api/payments',
		request: options,
		schema: Schemas.PAYMENT_ARRAY
	}
});

export const fetchPayment = (id, type) => ({
	[CALL_API]: {
		types: [PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE],
		endpoint: `api/payments/${type}/${id}`,
		schema: Schemas.PAYMENT
	}
});


export const setPaymentSubGrade = (paymentId, gradeId, onSuccess) => ({
	[CALL_API]: {
		types: [SET_SUBGRADE_REQUEST, SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE],
		endpoint: `api/payments/${paymentId}/${gradeId}`,
		method: 'PUT',
		onSuccess: onSuccess
	}
});

export const updatePaymentOption = (payment) => (dispatch) => {
	if (payment && payment.paymentMethod && payment.paymentMethod.name === 'Takepayments') {
		dispatch({
			[CALL_API]: {
				types: [TAKEPAYMENTS_CARD_UPDATE_REQUEST, TAKEPAYMENTS_CARD_UPDATE_SUCCESS, TAKEPAYMENTS_CARD_UPDATE_FAILURE],
				endpoint: 'api/paymentMethods/takepayments/cardUpdate',
				method: 'POST',
				request: { paymentId: payment.id },
				onSuccess: (response) => {
					if (response.redirectUrl) {
						const bodyParams = response.httpBodyParams || {};
						const form = document.createElement('form');
						form.method = 'POST';
						form.action = response.redirectUrl;
						form.style.display = 'none';
						Object.keys(bodyParams).forEach(key => {
							const input = document.createElement('input');
							input.name = key;
							input.value = bodyParams[key];
							input.type = 'hidden';
							form.appendChild(input);
						});
						document.body.appendChild(form);
						form.submit();
					}
				}
			}
		});
	}
};
